import { Component, OnInit } from "@angular/core";
import {
  MODALIDADES_PENSION,
  ESTATUS_CARD_DATA,
  FAQ_CARD,
  RESPONSE_TRACKING,
} from "@constants/tramite-pension-constant";
import { IEstadoTramitePensionResponse } from "@interfaces/estado-tramite-pension.response.interface";
import { StorageService } from "@services/storage/storage.service";
import { IFaqItem } from "@shared/common/interfaces/faq-card.interface";
import { EstadoTramiteStepperService } from "../../services/estado-tramite-stepper.service";
import { Util } from "@shared/common/utils/util";

@Component({
  selector: "app-modalidad-pension",
  templateUrl: "./modalidad-pension.component.html",
  standalone: false
})
export class ModalidadPensionComponent implements OnInit {
  titleFaq: string = "";

  statusCardData = ESTATUS_CARD_DATA[3];

  faqCardData: IFaqItem[] = [];

  constructor(
    private readonly tramiteStepper: EstadoTramiteStepperService,
    private readonly storageService: StorageService,
    private readonly util: Util,
  ) { }

  async ngOnInit() {
    this.tramiteStepper.setStepCurrent(4);
    await this.getDataInfoTramite();
  }

  async getDataInfoTramite() {
    const responseTracking: IEstadoTramitePensionResponse =
      await this.storageService.get(RESPONSE_TRACKING);
    const modalidadPension = responseTracking?.data?.modalidadPension;

    this.statusCardData.infoBoxMessage = responseTracking?.data?.resumen ?? '';
    const codigoTipoModalidad = (modalidadPension?.tipoModalidad || '').toUpperCase().trim();
    if (codigoTipoModalidad) {
      const descripcionModalidadApiNormalizada = this.util.convertirPrimeraLetraMayuscula(
        modalidadPension?.descripcionModalidad,
      );
      const glosaTipoModalidad =
        MODALIDADES_PENSION[codigoTipoModalidad]?.glosa
        || descripcionModalidadApiNormalizada
        || '-';
      const fechaSeleccionModalidad = this.util.formatearFechaParaVista(
        modalidadPension?.fechaSeleccionModalidad,
      );
      this.statusCardData.details = [
        {
          label: "Modalidad de pensión elegida",
          value: glosaTipoModalidad,
          isHeader: false,
        },
        {
          label: "Fecha de selección de modalidad",
          value: fechaSeleccionModalidad || '-',
          isHeader: false,
        },
        {
          label: "Tu pensión será pagada por",
          value: modalidadPension?.entidad || '-',
          isHeader: false,
        },
      ];
      this.titleFaq = FAQ_CARD[3]?.questions?.[0]?.title ?? '';
      this.faqCardData = this.obtenerDescripcionesPorTipoModalidad(codigoTipoModalidad);
    }
  }

  private obtenerDescripcionesPorTipoModalidad(tipoModalidad?: string | null): IFaqItem[] {
    if (!tipoModalidad) {
      return FAQ_CARD[2]?.questions?.[0]?.items[0]
        ? [FAQ_CARD[2].questions[0].items[0]]
        : [];
    }
    const codigoModalidad = (tipoModalidad || '').toUpperCase().trim();

    const descripionesModalidades = FAQ_CARD[2]?.questions?.[0]?.items ?? [];

    return descripionesModalidades
      .filter(item => item.codigosTipoModalidad?.includes(codigoModalidad))
      .map(item => ({ ...item }));
  }

}
